import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as backgroundColor from '../../config/backgroundColor';
import * as color from '../../config/colors';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';
import { CompareChartService } from './compare-chart.service';
import { ECharts, EChartOption } from 'echarts';
import { initOpts } from '../../config/initOpts';
import { ChartResizeService } from '../../service/chart-resize.service';
import { ChartOptionService } from '../../service/chart-option.service';
import { isNil } from 'lodash'

@Component({
  selector: 'bcac-compare-chart',
  templateUrl: './compare-chart.component.html',
  styleUrls: ['./compare-chart.component.scss']
})
export class CompareChartComponent implements OnInit {

  constructor(
    private compareChartService: CompareChartService,
    private commonService: CommonService,
    private chartOptionService: ChartOptionService,
    private chartResizeService: ChartResizeService
  ) { }

  chartTitle = {
    show: true,
    label: "图表标题"
  }

  // 布局设置
  // cardPadding
  cardPadding = "1rem";
  cardBgColor = "#FFF";
  chartTitleColor = "";

  // echart图表元素  
  chartBackgroundColor: string = "#FFF";
  chartColors: string[] = this.chartOptionService.getChartColors("default");
  chartTitles = this.chartOptionService.getChartTitle();
  chartLegend = this.chartOptionService.getChartLegend();
  chartGrid: EChartOption.Grid = this.commonService.changeFontSize().interval;
  chartxAxis: EChartOption.XAxis[] = this.compareChartService.getChartxAxis();
  chartyAxis: EChartOption.YAxis[] = this.compareChartService.getChartyAxis(1);
  chartTextStyle: EChartOption.TextStyle = this.chartOptionService.getTextStyle();
  lineChartSeries: EChartOption.Series = this.chartOptionService.getDefaultLineSeries();
  customChartSeries: EChartOption.SeriesCustom = this.chartOptionService.getCompareCustomSeries();
  chartTooltip: EChartOption.Tooltip = this.chartOptionService.getCompareCustomTooltip();
  chartSeriesList: EChartOption.Series[] = [];

  chartOption = {
    backgroundColor: this.chartBackgroundColor,
    title: this.chartTitle,
    color: this.chartColors,
    legend: this.chartLegend,
    tooltip: this.chartTooltip,
    grid: this.chartGrid,
    xAxis: this.chartxAxis,
    yAxis: this.chartyAxis,
    series: this.chartSeriesList,
    textStyle: this.chartTextStyle
  }

  initOpts = this.chartOptionService.getInitOpts();
  echartInstance: ECharts;
  onOptionInit(ec) {
    this.echartInstance = ec;
  }

  options;
  // echart配置项
  initEchart() {
    this.options = this.chartOption;
  }

  updateOption() {
    if (this.echartInstance) {
      this.echartInstance.setOption(this.options, true);
    }
  }

  /* 
    接口区
  */
  @Input()
  set bcacDarkMode(darkMode: boolean) {
    this.compareChartService.changeChartTitleDark(this, darkMode);
    this.compareChartService.chartBackgroundColorDarkMode(this.chartOption);
    this.compareChartService.xAxisDarkMode(this.chartxAxis);
    this.compareChartService.yAxisDarkMode(this.chartyAxis);
    this.compareChartService.colorsDarkMode(this.chartColors);
    this.compareChartService.legendDarkMode(this.chartLegend);
    this.compareChartService.seriesDarkMode(this.lineChartSeries, this.customChartSeries);

  }

  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.compareChartService.setSmallModeGrid(this.chartGrid);
      this.compareChartService.setSmallModePadding(this);
    }
  }

  legendPosition = 'bottom';
  @Input()
  set bcacLegendPosition(legendPostion: string) {
    this.legendPosition = legendPostion;
    this.compareChartService.setLegendPosition(this.chartGrid, this.chartLegend, this.legendPosition)
  }


  legendDataArr;
  @Input()
  set bcacChartData(chartData: any) {
    let legendDataList = [];
    if (!isNil(chartData) && chartData.hasOwnProperty('seriesName')) {

      legendDataList.push(
        {
          label: chartData.seriesName,
          value: chartData.seriesName,
          checked: true
        }
      )
      this.legendDataArr = legendDataList;
      this.compareChartService.buildSeries(chartData, this.chartSeriesList, this.chartxAxis, this.chartyAxis, this.lineChartSeries, this.customChartSeries);
    }
    this.updateOption();
  }


  legendChange(e) {
    this.compareChartService.topLegendChange(e, this.echartInstance);
  }


  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    this.dataSourceSelectData = value;
  }

  @Input()
  set bcacTitleSwith(titleSwitch: boolean) {
    this.chartTitle.show = titleSwitch;
  }

  @Input()
  set bcacTitle(title: string) {
    this.chartTitle.label = title
  }

  unit = '';
  @Input()
  set bcacUnit(unit: string) {
    this.unit = unit;
    this.compareChartService.setTooltipUnit(this.chartTooltip, unit, this.years);
  }

  @Input()
  set bcacXaxisName(xAxisName: string) {
    this.compareChartService.setXaxisName(this.chartxAxis, xAxisName);
  }

  @Input()
  set bcacYaxisName(yAxisName: string) {
    this.compareChartService.setYaxisName(this.chartyAxis, yAxisName)
  }

  @Input()
  set bcacYnameGap(yNameGap: number) {
    this.compareChartService.setYnameGap(this.chartyAxis, yNameGap);
  }

  @Input()
  set bcacXaxisLabelRotate(rotate) {
    this.compareChartService.setXaxisLabelRotate(this.chartxAxis, rotate);
  }

  years = ['', '']
  @Input()
  set bcacCompareYears(years: string[]) {
    this.years = years;
    this.compareChartService.setTooltipUnit(this.chartTooltip, this.unit, years)
  }

  // 加载等待
  _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }

  @Input()
  set bcacYAxisMin(yAxisMin: number | null | undefined) {
    this.compareChartService.setYAxisMin(this.chartyAxis, yAxisMin);
  }

  @Input()
  set bcacYAxisMax(yAxisMax: number | null | undefined) {
    this.compareChartService.setYAxisMax(this.chartyAxis, yAxisMax)
  }

  @Input()
  set bcacYAxisInterval(yAxisInterval) {
    this.compareChartService.setYAxisInterval(this.chartyAxis, yAxisInterval)
  }

  @Input()
  set bcacAxisSplitLine(splitLineShow: boolean) {
    this.compareChartService.setYAxisSplitLine(this.chartyAxis, splitLineShow)
    // this.chartResizeService.configSplitLine(splitLineShow, this.chartOption)
  }

  // X轴刻度间隔
  intervalDatas = [];
  intervalSelectedData;
  @Input()
  set bcacIntervalDatas(value: any[]) {
    this.intervalDatas = value;
  }

  intervalSelectedDataChange(e: any) {
    // 跟新图表interval
    this.compareChartService.setInterval(this.chartOption, e);
    this.updateOption();
  }

  axisScaleChange(e: any) {
    this.compareChartService.setInterval(this.chartOption, e);
    this.updateOption();
  }

  @Output()
  bcacDataSourceSelectEmit = new EventEmitter<any>();
  dataSourceChange($event) {
    this.bcacDataSourceSelectEmit.emit($event)
  }

  ngOnInit() {
    this.initEchart();
    this.updateOption();
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoResizeAdapt(this.echartInstance, this.options);
    })
  }

}
